import faunadb from 'faunadb'
const q = faunadb.query


export const getMakersTeams = function (client, makerTeamRefs) {
   console.log('makerTeamRefs: ', makerTeamRefs)
   return client.query(
      q.Map(
         makerTeamRefs,
         q.Lambda(teamRef => q.Get(teamRef)),
      ),
   )
}

export const getMakerByEmail = function (client, email) {
   return client.query(q.Get(q.Match(q.Index('maker_by_email'), email)))
}

export const getCompanyRefByName = function (client, name) {
   return client.query(q.Get(q.Match(q.Index('company_by_name'), name)))
}

export const getFullMakerState = function (client, email) {
   return client.query(
      q.Let(
         {
            maker: q.Get(q.Match(q.Index('maker_by_email'), email)),
            // prettier-ignore
            companies: q.Map(
               q.Select(['data', 'companyRefs'], q.Var('maker')),
               q.Lambda(companyRef => q.Get(companyRef))
            ),
            teams: q.Map(
               q.Select(['data', 'teamRefs'], q.Var('maker')),
               // q.Lambda(teamRef => {
               //    return {
               //       team: q.Get(teamRef),
               //       profile: q.Get(q.Select(['data', 'profileRef'], q.Get(teamRef))),
               //       company: q.Get(q.Select(['data', 'companyRef'], q.Get(teamRef))),
               //    }
               // }),
               q.Lambda(teamRef => q.Get(teamRef)),
            ),
            teamProfiles: q.Map(
               q.Select(['data', 'teamRefs'], q.Var('maker')),
               q.Lambda(teamRef => q.Get(q.Select(['data', 'profileRef'], q.Get(teamRef)))),
            ),
         },
         // the return object
         {
            maker: q.Var('maker'),
            companies: q.Var('companies'),
            // TODO: Rename this... (it also has the companies in it)
            // teamsAndTeamProfiles: q.Var('teams'),
            teams: q.Var('teams'),
            teamProfiles: q.Var('teamProfiles'),
         },
      ),
   )
}

export const getMakerByRef = function (client, makerRef) {
   return client.query(q.Get(makerRef))
}

export const getTeamProfileByRef = function (client, profileRef) {
   return client.query(q.Get(profileRef))
}

export const logout = function (client) {
   // passing `true here invalidates all tokens for the user, which for us currently seems like good practice
   return client.query(q.Logout(true))
}

export const updateUserInfo = function (client, email, data) {
   return client.query(q.Update(q.Select('ref', q.Get(q.Match(q.Index('maker_by_email'), email))), { data: data }))
}

export const getMakerTeamMembers = function (client, makerRefs) {
   return client.query(
      q.Map(
         makerRefs,
         q.Lambda(makerRef => q.Get(makerRef)),
      ),
   )
}

export const updateCompany = function (client, companyRef, data) {
   console.log(data)
   return client.query(
      q.Update(companyRef, { data })
   )
}

export const updateProfileDraft = function (client, profileRef, profileWithUpdatedData) {
   return client.query(
      q.Let(
         {
            updatedProfile: q.Update(profileRef, { data: profileWithUpdatedData })
         },
         q.Update(profileRef, {
            data: {
               lastDraftTs: q.Select('ts', q.Var('updatedProfile'))
            }
         })
      )
   )
}

export const publishDraft = function ({ client, profileRef, profileWithUpdatedData, isFirstPublish }) {
   return client.query(
      q.Let(
         {
            updatedProfile: q.Update(profileRef, { data: profileWithUpdatedData }),
         },
         q.If(
            isFirstPublish,
            q.Update(profileRef, {
               data: {
                  firstPublishTs: q.Select('ts', q.Var('updatedProfile')),
                  lastDraftTs: q.Select('ts', q.Var('updatedProfile')),
                  lastPublishTs: q.Select('ts', q.Var('updatedProfile'))
               }
            }),
            q.Update(profileRef, {
               data: {
                  lastDraftTs: q.Select('ts', q.Var('updatedProfile')),
                  lastPublishTs: q.Select('ts', q.Var('updatedProfile'))
               }
            }),
         )
      )
   )
}
